const resource = 'shipping_methods'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },
  get(id, params) {
    return $axios.$get(`/${resource}/${id}`, { params })
  },
  fetchFreeShippingThresholds() {
    return $axios.$get('/v2/free-shipping-thresholds')
  },

  getServiceName: name => 'shippingMethodService',
})
